import { Globe2 } from "lucide-react";

export function Team({ content, images = [] }) {
  const renderTeamCards = (teams, startIndex = 0) => (
    <div className="team-grid team-grid-split" data-testid={`team-grid-${startIndex + 1}`}>
      {teams.map(([region, representative, coverage], index) => {
        const teamIndex = startIndex + index;
        return (
          <article className="team-card" key={region} data-testid={`team-card-${teamIndex + 1}`}>
            <div className="portrait-placeholder" data-testid={`team-photo-placeholder-${teamIndex + 1}`}>
              {images[teamIndex]?.image ? (
                <img src={images[teamIndex].image} alt={`${representative} - ${region}`} data-testid={`team-photo-${teamIndex + 1}`} />
              ) : (
                <>
                  <Globe2 size={34} aria-hidden="true" />
                  <span>{content.photo}</span>
                </>
              )}
            </div>
            <div className="team-card-body">
              <h3 data-testid={`team-region-${teamIndex + 1}`}>{region}</h3>
              <p data-testid={`team-representative-${teamIndex + 1}`}>{representative}</p>
              <ul data-testid={`team-coverage-list-${teamIndex + 1}`}>
                {coverage.map((coverageItem) => (
                  <li key={coverageItem} data-testid={`team-coverage-${teamIndex + 1}-${coverageItem.toLowerCase().replaceAll(" ", "-")}`}>{coverageItem}</li>
                ))}
              </ul>
            </div>
          </article>
        );
      })}
    </div>
  );

  const firstTeams = (content.teams || []).slice(0, 2);
  const laterTeams = (content.teams || []).slice(2);

  return (
    <>
      <section id="team" className="section team-section" data-testid="team-section">
        <div className="section-heading wide compact-heading">
          <p className="overline" data-testid="team-overline">{content.overline}</p>
          <h2 data-testid="team-title">{content.title}</h2>
        </div>
        {renderTeamCards(firstTeams, 0)}
      </section>

      <section className="section team-section team-detail-section" data-testid="team-detail-section">
        <div className="section-heading wide compact-heading">
          <p className="overline" data-testid="team-detail-overline">{content.overline}</p>
          <h2 data-testid="team-detail-title">{laterTeams.map(([region]) => region).join(" / ") || content.title}</h2>
        </div>
        {renderTeamCards(laterTeams, 2)}
      </section>
    </>
  );
}